import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredKayakIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_3346_430)">
            <path
              d="M6.414 6.414C6.78894 6.03894 6.99957 5.53033 6.99957 5C6.99957 4.46967 6.78894 3.96105 6.414 3.586L5 2.172L2.172 5L3.586 6.414C3.96105 6.78894 4.46967 6.99957 5 6.99957C5.53033 6.99957 6.03894 6.78894 6.414 6.414Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M17.586 17.5861C17.2111 17.9611 17.0004 18.4697 17.0004 19.0001C17.0004 19.5304 17.2111 20.039 17.586 20.4141L19 21.8281L21.828 19.0001L20.414 17.5861C20.0389 17.2111 19.5303 17.0005 19 17.0005C18.4697 17.0005 17.9611 17.2111 17.586 17.5861Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M6.5 6.5L17.5 17.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M6.5 12.5L11.5 17.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#98FF4A"
            />
            <path
              d="M12.5 6.5L17.5 11.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#98FF4A"
            />
            <path
              d="M22 2.5C12.017 5.101 4.373 10.452 2 22C11.983 19.399 19.627 14.048 22 2.5Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
              fill="transparent"
            />
          </g>
          <defs>
            <clipPath id="clip0_3346_430">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_3346_438)">
            <path
              d="M6.414 6.414C6.78894 6.03894 6.99957 5.53033 6.99957 5C6.99957 4.46967 6.78894 3.96105 6.414 3.586L5 2.172L2.172 5L3.586 6.414C3.96105 6.78894 4.46967 6.99957 5 6.99957C5.53033 6.99957 6.03894 6.78894 6.414 6.414Z"
              fill="#98FF4A"
              fillOpacity="0.2"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M17.586 17.5861C17.2111 17.9611 17.0004 18.4697 17.0004 19.0001C17.0004 19.5304 17.2111 20.039 17.586 20.4141L19 21.8281L21.828 19.0001L20.414 17.5861C20.0389 17.2111 19.5303 17.0005 19 17.0005C18.4697 17.0005 17.9611 17.2111 17.586 17.5861Z"
              fill="#98FF4A"
              fillOpacity="0.2"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path d="M13 6L21 3H22L18.5 12L13 6Z" fill="#98FF4A" />
            <path
              d="M11.0837 17.9994L3.12671 21.1118L2.12681 21.1259L5.49967 12.0775L11.0837 17.9994Z"
              fill="#98FF4A"
            />
            <path
              d="M6.5 6.5L17.5 17.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M22 2.5C12.017 5.101 4.373 10.452 2 22C11.983 19.399 19.627 14.048 22 2.5Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
              fill="transparent"
            />
            <path
              d="M6.5 12.5L11.5 17.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
            <path
              d="M12.5 6.5L17.5 11.5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#262626"
            />
          </g>
          <defs>
            <clipPath id="clip0_3346_438">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredKayakIcon;
